"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let HandoverProtocol = class HandoverProtocol extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    contractId;
    onContract_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contractId");
    }
    revisionId;
    onRevision_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("revisionId");
    }
    handoverType;
    onHandover_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("handoverType");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.oid ?
            this.$fn.fetch('read_contract_protocol', {
                asResource: true,
                parameters: { id: this.oid }
            }) :
            this.$fn.fetch('get_contract_protocol_template', {
                asResource: true,
                parameters: {
                    contract_id: this.contractId,
                    revision_id: this.revisionId,
                    handover_type: this.handoverType,
                }
            });
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    handoverTypes;
    async $$load_handoverTypes() {
        return this.$fn.getEnumValuesFromSchema('HandoverType');
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['item', 'formName', 'formId', 'labelAlign', 'handoverTypes', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                formName: "handoverProtocol",
                formId: null,
                labelAlign: "left",
                handoverTypes: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("Contract", "Handover protocol"),
                    this.$fn.pgettext("HandoverType", this.item.handover_type, "Sentence"),
                ],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8584_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_closeModal_8588_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_8564662037462133_close(event, scope) {
        return await this.actions.evh_8564662037462133_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_closeModal_8592_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_script_8596_getActionArgs_value($event) {
        _.isEmpty($event.data) ? this.item : this.item.reset($event.data);
    }
    async act_1040167445267876_script_8596_getActionArgs($event) {
        return {
            value: () => this.act_1040167445267876_script_8596_getActionArgs_value($event),
        };
    }
    async evh_1040167445267876_success_8595_getWhen($event) {
        return !!$event.data;
    }
    async act_1040167445267876_crud_8594_getActionArgs($event) {
        return {
            objectType: "contract_protocol",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_5534025912102772_reload(event, scope) {
        return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
    }
    async evh_5534025912102772_close(event, scope) {
        return await this.actions.evh_5534025912102772_close.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_emit_8602_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data,
        };
    }
    async evh_5534025912102772_changed(event, scope) {
        return await this.actions.evh_5534025912102772_changed.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_script_8606_getActionArgs_value($event) {
        _.isEmpty($event.data) ? this.item : this.item.reset($event.data);
    }
    async act_1548630417156826_script_8606_getActionArgs($event) {
        return {
            value: () => this.act_1548630417156826_script_8606_getActionArgs_value($event),
        };
    }
    async evh_1548630417156826_success_8605_getWhen($event) {
        return !!$event.data;
    }
    async act_1548630417156826_crud_8604_getActionArgs($event) {
        return {
            objectType: "contract_protocol",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeComponent_8608_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8584 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8584_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8583 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8584,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8583],
        });
        const act_2248226175642056_closeModal_8586 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_8585 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_8586,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8585],
        });
        const act_8564662037462133_closeModal_8588 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_8564662037462133_closeModal_8588_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_close_8587 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeModal_8588,
            event: "close",
            displayName: "closeModal",
        });
        const evh_8564662037462133_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_close_8587],
        });
        const act_8564662037462133_reloadComponentData_8590 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_8589 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_8590,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_8589],
        });
        const act_8564662037462133_closeModal_8592 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_8564662037462133_closeModal_8592_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_deleted_8591 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeModal_8592,
            event: "deleted",
            displayName: "closeModal",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_8591],
        });
        const act_1040167445267876_script_8596 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1040167445267876_script_8596_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_8595 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_script_8596,
            event: "success",
            when: this.evh_1040167445267876_success_8595_getWhen,
            displayName: "script",
        });
        const act_1040167445267876_crud_8594 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_8594_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_8595],
        });
        const evh_1040167445267876_submit_8593 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_8594,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8593],
        });
        const act_5534025912102772_reloadComponentData_8598 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5534025912102772_reload_8597 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_reloadComponentData_8598,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_5534025912102772_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_reload_8597],
        });
        const act_5534025912102772_closeComponent_8600 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_5534025912102772_close_8599 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_closeComponent_8600,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_5534025912102772_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_close_8599],
        });
        const act_5534025912102772_emit_8602 = new core_1.actions.EmitAction({
            actionArgs: this.act_5534025912102772_emit_8602_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_changed_8601 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_emit_8602,
            event: "changed",
            displayName: "emit",
        });
        const evh_5534025912102772_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_changed_8601],
        });
        const act_1548630417156826_script_8606 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1548630417156826_script_8606_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_8605 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_script_8606,
            event: "success",
            when: this.evh_1548630417156826_success_8605_getWhen,
            displayName: "script",
        });
        const act_1548630417156826_crud_8604 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1548630417156826_crud_8604_getActionArgs,
            displayName: "save",
            events: [evh_1548630417156826_success_8605],
        });
        const evh_1548630417156826_clickPreventStop_8603 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_crud_8604,
            event: "click.prevent.stop",
            displayName: "save",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_8603],
        });
        const act_1419464017721962_closeComponent_8608 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1419464017721962_closeComponent_8608_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_8607 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_8608,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_8607],
        });
        return {
            act_7315092382398562_closeModal_8584,
            evh_7315092382398562_close_8583,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_8586,
            evh_2248226175642056_close_8585,
            evh_2248226175642056_close,
            act_8564662037462133_closeModal_8588,
            evh_8564662037462133_close_8587,
            evh_8564662037462133_close,
            act_8564662037462133_reloadComponentData_8590,
            evh_8564662037462133_reload_8589,
            evh_8564662037462133_reload,
            act_8564662037462133_closeModal_8592,
            evh_8564662037462133_deleted_8591,
            evh_8564662037462133_deleted,
            act_1040167445267876_script_8596,
            evh_1040167445267876_success_8595,
            act_1040167445267876_crud_8594,
            evh_1040167445267876_submit_8593,
            evh_1040167445267876_submit,
            act_5534025912102772_reloadComponentData_8598,
            evh_5534025912102772_reload_8597,
            evh_5534025912102772_reload,
            act_5534025912102772_closeComponent_8600,
            evh_5534025912102772_close_8599,
            evh_5534025912102772_close,
            act_5534025912102772_emit_8602,
            evh_5534025912102772_changed_8601,
            evh_5534025912102772_changed,
            act_1548630417156826_script_8606,
            evh_1548630417156826_success_8605,
            act_1548630417156826_crud_8604,
            evh_1548630417156826_clickPreventStop_8603,
            evh_1548630417156826_clickPreventStop,
            act_1419464017721962_closeComponent_8608,
            evh_1419464017721962_clickPreventStop_8607,
            evh_1419464017721962_clickPreventStop,
            save: act_1548630417156826_crud_8604,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], HandoverProtocol.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], HandoverProtocol.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], HandoverProtocol.prototype, "contractId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contractId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], HandoverProtocol.prototype, "onContract_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], HandoverProtocol.prototype, "revisionId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('revisionId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], HandoverProtocol.prototype, "onRevision_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], HandoverProtocol.prototype, "handoverType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('handoverType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], HandoverProtocol.prototype, "onHandover_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], HandoverProtocol.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], HandoverProtocol.prototype, "onSize", null);
HandoverProtocol = __decorate([
    (0, vue_property_decorator_1.Component)()
], HandoverProtocol);
exports.default = HandoverProtocol;
vue_property_decorator_1.Vue.component("HandoverProtocol", HandoverProtocol);
